import { render, staticRenderFns } from "./qkk.vue?vue&type=template&id=2f13baa2&scoped=true&"
import script from "./qkk.vue?vue&type=script&lang=js&"
export * from "./qkk.vue?vue&type=script&lang=js&"
import style0 from "./qkk.vue?vue&type=style&index=0&id=2f13baa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13baa2",
  null
  
)

export default component.exports